import useSWR from 'swr'
import { getDocs, Page, PagesParent } from '../../firebase'
import { sortedPagesRef } from '../../models/page'

export const usePages = (parent?: PagesParent, defaultPages?: Page[]) => {
  // pagesは何回も取得される可能性が高いのでキャッシュする
  const {
    data: pages,
    error,
    isLoading: loading,
    mutate,
  } = useSWR<Page[] | undefined, Error>(
    parent ? `${parent.parent_id}/${parent.id}/pages` : null,
    async () => {
      const pagesSnapshot = parent
        ? await getDocs(sortedPagesRef(parent.ref))
        : undefined
      return pagesSnapshot?.docs.map((doc) => doc.data())
    },
    {
      // categoriesはmutate関数による再検証のみを行う
      // これによりカテゴリが同じユーザに対して繰り返し取得されることを防ぐ
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      fallbackData: defaultPages,
    }
  )
  return { pages, error, loading, mutate }
}
